import React from 'react';
import WholesalePartsHubHeader from '../wholesale-parts-hub-header';
import WholesalePartsHubSectionNavigation from '../wholesale-parts-hub-section-navigation';
import WholesalePartsHubSection from '../wholesale-parts-hub-section';

const WholesalePartsHubPartsOverview: React.FC = () => (
  <div className="wpc-content">
    <WholesalePartsHubHeader>Wholesale Parts Hub</WholesalePartsHubHeader>
    <WholesalePartsHubSection
      title="Volvo Genuine Parts"
      id="volvo-genuine-parts"
    >
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/1.jpg`} />
        <div>
          <p>
            <strong>
              At Volvo Cars, we take our parts seriously and want to share this
              information as to why. Volvo Genuine Parts work seamlessly
              together to form one safe, reliable, and premium vehicle designed
              to protect those inside.
            </strong>
          </p>
          <p>
            <strong>
              Why Purchase Volvo Genuine Parts and not Aftermarket Parts?
            </strong>
          </p>
          <p>
            Volvo Genuine Parts are designed for safety, structural integrity,
            optimal fit, and value. We are confident in the quality of Volvo
            Genuine Parts and stand by them with the Volvo Genuine Parts
            two-year warranty (US Only).
          </p>
          <p>
            <strong>Why Genuine?</strong>
          </p>
          <p>The standard of safety</p>
          <ul>
            <li>
              Awarded the most 2021 TOP SAFETY PICK+ awards of any
              manufacturer,* only Volvo Genuine Parts are designed to work
              specifically with the safety features in every Volvo Car. Volvo
              engineers design each component with safety in mind. It’s
              important to keep our cars as safe as they were when they left the
              Volvo factory.
            </li>
          </ul>
          <p>Structural and Mechanical Integrity</p>
          <ul>
            <li>
              Everything from the suspension components to clips and screws are
              designed to have purpose. The materials are carefully chosen for
              peak performance under any condition. These superior materials
              ensure each component performs its job perfectly. In case of wear
              or repair, replacing Volvo Genuine Parts with aftermarket options
              may compromise the integrity of the repair or possibly the Volvo;
              the lesser quality and material type may result in squeaks, leaks,
              or other failures.
            </li>
          </ul>
          <p>Perfect Fit</p>
          <ul>
            <li>
              Volvo Genuine Parts are designed to fit perfectly. The same parts
              you purchase at your local authorized Volvo retailer were used to
              build the Volvo. The fix is exact with no compromise. Avoid
              purchasing generic aftermarket parts that were designed to fit
              many car types without fit or quality in mind.
            </li>
          </ul>
          <p>Value</p>
          <ul>
            <li>
              Volvo Cars manufactures cars and parts globally allowing for
              production-based volume savings. Because we have economies of
              scale, we can extend the savings to you through fair pricing while
              maintaining original uncompromised quality.
            </li>
          </ul>
          <p>
            <em>Make the right choice by only using Volvo Genuine Parts</em>
          </p>
          <div className="footnote">
            <p>
              <small>*As of April 2021</small>
            </p>
          </div>
        </div>
      </div>
    </WholesalePartsHubSection>
    <div className="divider" />
    <WholesalePartsHubSection title="Maintenance Parts" id="maintenance-parts">
      <WholesalePartsHubSectionNavigation
        items={[
          {
            text: 'Battery',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-battery',
          },
          {
            text: 'Brake Pads',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-brake-pads',
          },
          {
            text: 'Brake Discs',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-brake-discs',
          },
          {
            text: 'Cabin Air Filter',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-cabin-air-filter',
          },
          {
            text: 'Engine Air Filter',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-engine-air-filter',
          },
          {
            text: 'Oil Filter',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-oil-filter',
          },
          {
            text: 'Tires',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-tiers',
          },
          {
            text: 'Wiper Blades',
            href: '/wholesale-parts-hub/parts-overview#maintenance-parts-wiper-blades',
          },
        ]}
      />
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/2.jpg`} />
        <div>
          <p id="maintenance-parts-battery">
            <strong>Battery</strong>
          </p>
          <p>
            Today’s Volvos have over 60 electrical systems and components, often
            requiring power at the same time. Volvo Genuine Batteries are
            designed around the specific power consumption and charging
            capability of Volvo electrical systems.
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Genuine Volvo Genuine Batteries are manufactured from materials
              sourced without the use of child labor.
            </li>
            <li>
              Volvo Genuine Batteries are and are built to last and tested in
              some of the world’s harshest climates.
            </li>
            <li>
              Every Volvo’s power consumption requirement differs. Using Volvo
              Genuine Batteries ensures the Volvo has the correct battery with
              the proper power output to support all onboard systems.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/3.jpg`} />
        <div>
          <p id="maintenance-parts-brake-pads">
            <strong>Brake Pads</strong>
          </p>
          <p>
            Developed and tested to work in harmony with Volvo’s sophisticated
            braking system together with Volvo Genuine Brake Discs making sure
            that the Volvo stops at the right moment in all types of road
            conditions.
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Not all brake pads are the same. Brake pads are manufactured from
              a variety of materials which can impact the stopping distance of a
              vehicle. Volvo Genuine Brake Pad materials are carefully selected
              to work together with the rest of the sophisticated brake system.
            </li>
            <li>
              “City Safety” has a safety feature that automatically applies
              brake force to slow down or stop the Volvo. The function is
              designed to be activated as late as possible in order to avoid
              unnecessary intervention. The timing is precisely calibrated to
              Volvo Genuine Brake Pads to stop the Volvo at the proper time or
              distance.
            </li>
            <li>
              Using Volvo Genuine Brake Pads will help ensure proper
              functionality of the braking system.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/4.jpg`} />
        <div>
          <p id="maintenance-parts-brake-discs">
            <strong>Brake Discs</strong>
          </p>
          <p>
            Developed and tested as a crucial component of Volvo’s sophisticated
            braking system, Volvo Genuine brake discs in harmony with Volvo
            Genuine Brake Pads, are designed to stop the Volvo at the
            appropriate time in any road condition.
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Brake Discs are one of the most important parts of a vehicle’s
              safety. Their quality directly impacts the stopping capability of
              a vehicle.
            </li>
            <li>
              Volvo Genuine Brake Disks are made of a high-quality durable
              material allowing them to perform optimally in sync with Volvo
              Genuine Brake Pads and Volvo’s sophisticated braking system.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/5.jpg`} />
        <div>
          <p id="maintenance-parts-cabin-air-filter">
            <strong>Cabin Air Filter</strong>
          </p>
          <p>
            Ensures a healthy in-car environment for the occupants by collecting
            more particles than some of the aftermarket options.
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Not all filters are created equal. They may look similar, but
              their material density and surface area aren’t. If the material is
              too dense, air flow is weakened losing efficiency and causing
              possible damage to the air conditioning or heating system. If the
              material is too thin, the filtration is weakened. A precise
              filtration material is needed for the best performance.
            </li>
            <li>
              Filter fit can make or break its purpose. If the air filter
              doesn’t fit properly, air can flow around it essentially making
              the filter useless. The fit must be exact! Always remember that
              Volvo Genuine cabin air filter will fit exactly right and provide
              the cleanest air for the cabin.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/17.jpg`} />
        <div>
          <p id="maintenance-parts-engine-air-filter">
            <strong>Engine Air Filter</strong>
          </p>
          <p>
            Offers superior filtration efficiency and promotes proper airflow to
            protect the Volvo&apos;s engine against premature wear.{' '}
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Engines have extremely tight tolerances and are sensitive to
              foreign debris. Having a tight seal around the air filter combined
              with the proper filtration material will allow for the engine to
              get the airflow efficiency necessary. This will allow for optimal
              fuel economy and prolonged engine life.
            </li>
            <li>
              Aftermarket engine air filters are often made from less durable
              materials. In most cases, they compromise fit and material
              quality, which are both critical to the filter’s functionality.
            </li>
            <li>
              Volvo Cars tests and tunes all engines using only Volvo Genuine
              Engine Air Filters. The airflow and filtration that Volvo Genuine
              Filters provide will help the engine to perform to its maximum
              capability.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/18.jpg`} />
        <div>
          <p id="maintenance-parts-oil-filter">
            <strong>Oil Filter</strong>
          </p>
          <p>
            Keeping oil free of unwanted debris and particles can help prevent
            premature engine wear and ensure the engine performs as designed.
            All Volvo engines are tested exclusively with Volvo’s proprietary
            blend of Castrol™ EDGE™ Oil together with Volvo Genuine Oil Filters.
            Ensure the Volvo has the best protection possible.{' '}
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Volvo Genuine Oil Filters are made from a specific material that
              allows for proper oil flow and collects debris particles which can
              damage the engine&apos;s inner workings if not entrapped. Other
              filters can&apos;t guarantee the Volvo engine will work as
              efficiently as it should with a Volvo Genuine Oil Filter.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/19.jpg`} />
        <div>
          <p id="maintenance-parts-tires">
            <strong>Tires</strong>
          </p>
          <p>
            Volvo takes great care to work with tire manufacturers to ensure the
            specs live up to the highest standards for performance and safety.
            Make sure to source tires from an authorized Volvo Retailer to
            ensure that the Volvo is uncompromised.
          </p>
          <p>Facts</p>
          <ul>
            <li>
              When a Volvo is tested, its stability control system and braking
              systems are tested with a specific type of tire that is carefully
              picked by Volvo engineers.
            </li>
            <li>
              Having the correct tire on a Volvo is important to the vehicle’s
              stability in certain road conditions and its ability to stop.
            </li>
            <li>
              Purchasing tires from an authorized Volvo retailer is simple,
              easy, and provides the best value.
            </li>
          </ul>
        </div>
      </div>
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/20.jpg`} />
        <div>
          <p id="maintenance-parts-wiper-blades">
            <strong>Wiper Blades</strong>
          </p>
          <p>
            Volvo Genuine Wiper Blades ensure a clean streak-free Volvo
            windshield.
          </p>
          <p>Facts</p>
          <ul>
            <li>
              Volvo Genuine Wiper Blades are designed to fit the exact size and
              curvature of the windshield.
            </li>
            <li>
              Certain Volvo Genuine Wiper Blades are specially designed to
              deploy windshield washer fluid through a series of holes along the
              edge of the blade. This is designed to minimize glare when
              cleaning the windshield.
            </li>
            <li>
              Volvo Genuine Wiper Blades are designed around the exact Volvo for
              which they are intended. A couple of examples:
              <ul>
                <li>
                  They are designed to keep pressure on the wipers while at
                  highway speeds to ensure maximum contact.
                </li>
                <li>
                  The size and shape of the blades are directly correlated with
                  the size and shape of the Volvo windshield. Aftermarket blades
                  are designed in generic sizes.
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </WholesalePartsHubSection>
    <div className="divider" />
    <WholesalePartsHubSection
      title="Volvo Remanufactured Exchange Parts"
      id="volvo-remanufactured-exchange-parts"
    >
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/10.jpg`} />
        <div>
          <p>
            Volvo Cars has been remanufacturing spare parts since the 1940s
            because it is a sustainable approach – better than recycling, in
            fact. Compared with a newly made part, a remanufactured component
            saves up to 85 percent in raw materials and consumes up to 80
            percent less energy – significantly reducing CO2 emissions. During
            the process the part is upgraded to the latest version of that
            component. Once a part has been remanufactured to meet high quality
            and safety standards, it enters the Volvo Cars Parts Exchange System
            – continuing its lifecycle, reducing the environmental impact.
          </p>
        </div>
      </div>
    </WholesalePartsHubSection>
    <div className="divider" />
    <WholesalePartsHubSection
      title="Volvo Genuine Classic Parts"
      id="volvo-genuine-classic-parts"
    >
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/11.jpg`} />
        <div>
          <p>
            Need a new grille for your vintage 1960’s P1800 coupe, a radiator
            hose for a 262C, or you need new upholstery for your 244 sedan?
            However rare or old the Volvo model, there’s a good chance that your
            local Volvo retailer can source the parts you need. To ensure
            maximum Genuine Classic Parts availability, Volvo Cars partnered
            with a Swedish company that provides your local Volvo retailer with
            access to rare parts. Contact your local Volvo retailer today to
            learn more.
          </p>
        </div>
      </div>
    </WholesalePartsHubSection>
    <div className="divider" />
    <WholesalePartsHubSection
      title="Volvo Genuine Accessories"
      id="volvo-genuine-accessories"
    >
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/13.jpg`} />
        <div>
          <p>
            At Volvo, we think about our customers and their needs from the very
            beginning of car design. Take that idea a step further with
            accessories that enhance their vehicle from every angle. Whether you
            aim to optimize the Volvo’s drivability and acceleration or add some
            customization, you can view every Volvo Genuine Accessory available
            to personalize the Volvo.{' '}
          </p>
          <p>
            Our accessories undergo rigorous testing to make sure they perform
            perfectly on your vehicle not only from a safety perspective, but
            also from a practical one. Give the Volvo a personal touch with
            accessories built just for it.
          </p>
        </div>
      </div>
    </WholesalePartsHubSection>
    <div className="divider" />
    <WholesalePartsHubSection title="Warranty" id="warranty">
      <div className="section-grid">
        <img src={`${process.env.CDN_URL}/wholesale-parts-hub/12.jpg`} />
        <div>
          <p>
            Volvo Genuine Parts are manufactured to the highest quality
            standard. When purchased from an authorized Volvo retailer Parts
            Department, Volvo Genuine Parts carry a two-year warranty* (US Only)
            from the purchase date for defects.
          </p>
          <p>
            <small>
              *This warranty does not cover accessories, wear items or
              consumables.
            </small>
          </p>
        </div>
      </div>
    </WholesalePartsHubSection>
    {/* language=CSS */}
    <style jsx>{`
      .wpc-content {
        padding: 2rem 3rem;
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        min-height: 30rem;
      }

      strong {
        font-weight: 500;
      }

      .divider {
        margin: 3rem auto;
        height: 1px;
        background-color: #eee;
        width: 80%;
      }

      .section-grid {
        position: relative;
        display: flex;
        align-items: flex-start;
        gap: 1rem;
      }

      @media screen and (max-width: 850px) {
        .section-grid {
          flex-wrap: wrap;
        }
      }

      .section-grid img {
        padding-top: 1rem;
        width: 200px;
        object-fit: contain;
      }

      img {
        width: 200px;
      }
    `}</style>
  </div>
);

export default WholesalePartsHubPartsOverview;
